"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Support computePages function by providing the first step for the middle buttons
 * @param showLeftDots
 * @param showRightDots
 * @param currentPage
 * @param range
 * @param numberOfPages
 * @returns the first number of the middle series of buttons
 */
function getFirstStep(showLeftDots, showRightDots, currentPage, range, numberOfPages) {
  if (showLeftDots) {
    if (showRightDots) {
      return currentPage - Math.floor(range / 2);
    }

    return numberOfPages - range;
  }

  return 2;
}
/**
 * Support computePages function by providing the last step for the middle buttons
 * @param firstStep
 * @param range
 * @param numberOfPages
 * @returns the last number of the middle series of buttons
 */


function getLastStep(firstStep, range, numberOfPages) {
  if (firstStep + range > numberOfPages) return numberOfPages;
  return firstStep + range;
}
/**
 * Create an array of pages that should be displayed. -1 indicates a break (eg ellipsis)
 * @param currentPage - the page that is selected
 * @param numberOfPages - the total number of pages
 * @param range - the range of displayed buttons (other than the first and the last)
 * @returns An array with the pages that should be displayed
 */


function computePages(currentPage, numberOfPages, range) {
  if (numberOfPages <= 0) return [];
  if (numberOfPages === 1) return [1];
  var pages = [1];
  var showDots = numberOfPages > range + 2;
  var showLeftDots = showDots && currentPage > Math.floor(range / 2) + 2;
  var showRightDots = showDots && currentPage < numberOfPages - (Math.floor(range / 2) + 1);
  var firstStep = getFirstStep(showLeftDots, showRightDots, currentPage, range, numberOfPages);
  var lastStep = getLastStep(firstStep, range, numberOfPages); // add left dots

  if (showLeftDots) {
    pages.push(-1);
  }

  for (var step = firstStep; step < lastStep; step++) {
    pages.push(step);
  } // add right dots


  if (showRightDots) {
    pages.push(-1);
  }

  pages.push(numberOfPages);
  return pages;
}

var _default = computePages;
exports["default"] = _default;
//# sourceMappingURL=computePages.js.map